import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { NgcCookieConsentService } from 'ngx-cookieconsent';
import { EventBusService } from './event-bus.service';
import { AppEvent } from '@models/events/app-event.enum';
import { PurchaseContainer } from '@models/purchase-container.model';

declare function initTiktokPixel(id: string): any;
declare function tiktokPageView(): any;
declare function tiktokEvent(event: string, data: any): any;

@Injectable({
  providedIn: 'root'
})
export class TiktokPixelService {
  allowed: boolean = false;
  tiktokId: string | undefined = environment.tiktokPixelId;

  constructor(
    private cookieService: NgcCookieConsentService,
    private eventBusService: EventBusService
  ) { }

  init() {
    if (this.tiktokId && this.cookieService.hasConsented()) {
      this.allowed = true;
      initTiktokPixel(this.tiktokId);
      this.subscribeToEvents();
    }
  }

  private subscribeToEvents(): void {
    this.eventBusService.on(AppEvent.Purchase, (purchaseContainer: PurchaseContainer) => {
      this.trackPurchase(
        purchaseContainer.reservation.items.length,
        purchaseContainer.order.amount,
        purchaseContainer.order.currency
      );
    });
  }

  pageView() {
    if (this.allowed) {
      tiktokPageView();
    }
  }

  trackPurchase(quantity: number, value: string, currency: string) {
    if (this.allowed) {
      tiktokEvent('purchase', {
        quantity,
        value,
        currency
      });
    }
  }
}
